import React, { FC, useEffect } from 'react';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readyIndicator?: any | undefined;
}

export const SnapReady: FC<Props> = (props: Props) => {
  const { readyIndicator } = props;

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).snapWaitForSelector = 'div.snap-ready';
  }, []);

  return <div style={{ display: 'none' }} className={readyIndicator ? 'snap-ready' : 'snap-loading'} />;
};
